import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'searchFilter'
})
export class SearchFilterPipe implements PipeTransform {

  transform(list: any[], filterText: string): any {
    console.log("Came Here on pipe");
    return list ? list.filter(item => item.bookName.search(new RegExp(filterText, 'i')) > -1) : [];
  }

}
